import React from "react";
import { getAdminChallenges } from "api/admin/challenges";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, FormControl, TextField, FormControlLabel, Checkbox, InputLabel, Select, MenuItem } from "@material-ui/core";
import i18n from "./i18n";

type Filters = Parameters<typeof getAdminChallenges>[0];

interface ChallengeFilterDialogProps {
    filters: Filters,
    show: boolean,
    onClose: () => void,
    onRefreshTable: () => void,
    onSetFilters: (filters: Filters) => void,
}

// filter bookings dialog
const ChallengeFilterDialog = ({ filters, show, onClose, onRefreshTable, onSetFilters }: ChallengeFilterDialogProps) => {
    const handleChange = (event: any) => {
        const value = event.target.value as string;
        if (value === "true") {
            onSetFilters({ ...filters, isActive: true });
        } else if (value === "false") {
            onSetFilters({ ...filters, isActive: false });
        } else {
            onSetFilters({ ...filters, isActive: undefined });
        }
    };

    const handleReset = () => {
        onSetFilters({ ...filters, isActive: undefined, isBlueprint: undefined, query: undefined });
        onRefreshTable();
        onClose();
    };

    const handleApply = () => {
        onRefreshTable();
        onClose();
    };

    // render
    return (
        <Dialog
            fullWidth
            open={show}
            onClose={onClose}
        >
            <DialogTitle>{i18n.filter}</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    {/* query */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={i18n.query}
                            value={filters.query || undefined}
                            onChange={(e) => onSetFilters({ ...filters, query: (e.target.value === "" ? undefined : e.target.value) })}
                        />
                    </Grid>
                    {/* isactive */}
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel id="status-label-select-id">{i18n.status}</InputLabel>
                            <Select
                                labelId="status-lable-id"
                                id="demo-simple-select"
                                value={(filters.isActive ? "true" : (filters.isActive === false ? "false" : "all"))}  // eslint-disable-line
                                label={i18n.isActive}
                                onChange={handleChange}
                            >
                                <MenuItem value="all">{i18n.all}</MenuItem>
                                <MenuItem value="true">{i18n.active}</MenuItem>
                                <MenuItem value="false">{i18n.inActive}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    {/* setIsBlueprint */}
                    <Grid item xs={12}>
                        <FormControl>
                            <FormControlLabel
                                control={(
                                    <Checkbox
                                        checked={filters.isBlueprint}
                                        color="primary"
                                        onChange={(e) => onSetFilters({ ...filters, isBlueprint: (e.target.checked ? true : undefined) })}
                                    />
                                )}
                                label={i18n.isBlueprint}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color="secondary" onClick={handleReset} style={{ marginRight: "auto" }}>
                    {i18n.reset}
                </Button>
                <Button color="secondary" onClick={onClose}>
                    {i18n.cancel}
                </Button>
                <Button color="primary" onClick={handleApply}>
                    {i18n.apply}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChallengeFilterDialog;
